import React, {useState} from 'react';

import Constants from "../../config/constants";
import OImg from "../OImg";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import SplitComponent from "./SplitComponent";
import {updateBookmark} from "../../actions";
import {connect} from "react-redux";
import Swal from "sweetalert2";
import DetailsCliffRouteItem from "./DetailsCliffRouteItem";
import {Box} from "@mui/material";
import SwitchSecteur from "./SwitchSecteur";

const DetailsComponent = ({t, route, type, bookmark, onUpdateBookmark: onpdateBookmarkState}) => {
    const mediaBigData = route?.media_big_data;
    const tickingRootUrl = window.location.pathname.replace(/\/details$/g, '');
    const currentPath = window.location.pathname;
    let topContent = null, bottomContent = null;
    const [openId, setOpenId] = useState(null);

    // const getSecteurLink = (fromSlug, toSlug) => {
    //     //TODO what if current secteur is stored and not the other one ?
    //     return window.location.pathname.replace(fromSlug, toSlug);
    // }

    //const auth = useAuth();
    //const {data} = useUser(auth.user?.email, i18n.language);
    //const storedRoutes = Array.isArray(data?.user?.customerRoutes) ? data.user.customerRoutes : [];
    //const routeSaved = Array.isArray(storedRoutes) ? storedRoutes.find((el) => el.slug === route.slug) : false;

    //const {mutateAsync} = useStoredRouteUpdate(i18n.language);
    //const isCurrentPageBookmarked = route?.id === bookmark?.id;
    const lastPageBookmarked = bookmark?.id;

    const setOpenIdCallback = (openIdCallback) => {
        if (openId === openIdCallback) {
            setOpenId(null);
        } else {
            setOpenId(openIdCallback);
        }
    }
    //
    // const unsaveRoute = async () => {
    //     await mutateAsync({
    //         id: route.id,
    //         action: 'remove',
    //     });
    // }

    const onUpdateBookmark = (bookmark) => {
        //Suppression du bookmark
        if (bookmark.id === null) {
            //Suppression du bookmark et de la voie enregistrée ?
            // if (routeSaved){
            //     Swal.fire({
            //         titleText: t('SecteurComponent.bookmark.remove_bookmark.title'),
            //         icon: 'success',
            //         text: t('SecteurComponent.bookmark.remove_bookmark.text'),
            //         showCancelButton: true,
            //         confirmButtonText: t('SecteurComponent.bookmark.remove_bookmark.confirmButton'),
            //         cancelButtonText: t('SecteurComponent.bookmark.remove_bookmark.cancelButton'),
            //         reverseButtons: true
            //     }).then((result) => {
            //         if (result.value) {
            //             //Redirection pour le moment
            //             //setRedirectTo('/activation');
            //             // if (isCurrentPageBookmarked) {
            //             //     unsaveRoute();
            //             // } else {
            //             //     saveRoute();
            //             // }
            //         } else if (
            //             /* Read more about handling dismissals below */
            //             result.dismiss === Swal.DismissReason.cancel
            //         ) {
            //         }
            //
            //         onpdateBookmarkState(bookmark);
            //     });
            // }
            onpdateBookmarkState(bookmark);
        } else {
            //AJout du bookmark et de la voie enregistrée ?
            //if (!routeSaved && lastPageBookmarked) {
            if (lastPageBookmarked) {
                Swal.fire({
                    titleText: t('SecteurComponent.bookmark.update_bookmark.title'),
                    icon: 'question',
                    text: t('SecteurComponent.bookmark.update_bookmark.text'),
                    showCancelButton: true,
                    confirmButtonText: t('SecteurComponent.bookmark.update_bookmark.confirmButton'),
                    cancelButtonText: t('SecteurComponent.bookmark.update_bookmark.cancelButton'),
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        //Redirection pour le moment
                        //setRedirectTo('/activation');
                        // if (isCurrentPageBookmarked) {
                        //     unsaveRoute();
                        // } else {
                        //     saveRoute();
                        // }
                        onpdateBookmarkState(bookmark);
                    } else if (
                        /* Read more about handling dismissals below */
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                    }
                });
            } else {
                onpdateBookmarkState(bookmark);
            }
        }

    }

    if (mediaBigData) {
        topContent = <div className="w-100 h-100 img-container">
            <OImg
                src={mediaBigData}
                className={'mb-3'}
                withZoom={true}
                bookmark={bookmark}
                onUpdateBookmark={onUpdateBookmark}
                routeBookmark={{
                    id: route.id,
                    title: route.fullLabel,
                    url: currentPath
                }}
            />
        </div>;
    }

    // const {mutateAsync, status: statusSaving, error: errorSaving } = useBookmarkUpdate(i18n.language);
    //
    // const setBookmark = async () => {
    //     await mutateAsync({
    //         id: route.id,
    //         type: type,
    //         action: 'add',
    //     });
    // }
    //
    // const removeBookmark = async () => {
    //     await mutateAsync({
    //         id: route.id,
    //         type: type,
    //         action: 'remove',
    //     });
    // }

    if (type === Constants.TypeTopo.FALAISE) {
        bottomContent =
                    <React.Fragment>
                        <Box display="flex" sx={{p:0, alignItems: 'flex-start'}} className="sticky bg-white" style={{zIndex: 10}}>
                            <Box flexGrow={1} pr={1}>
                                <h3 className="mt-1 ml-2">{t('DetailsScreen.route_list.title')}</h3>
                            </Box>
                            {(route?.previousSlug || route?.nextSlug) && <Box pr={3}>
                                <SwitchSecteur
                                    isSwipeActive={false}
                                    details={true}
                                    route={route}/>
                            </Box>}
                        </Box>

                        <table className="table table-striped-cliffroute table-sm">
                            {/*<thead>*/}
                            {/*    <tr>*/}
                            {/*        <th style={{width: '90px'}}>Numéro</th>*/}
                            {/*        <th>Nom</th>*/}
                            {/*        <th>Equipé par</th>*/}
                            {/*        <th style={{width: '90px'}}>Niveau</th>*/}
                            {/*        <th style={{width: '45px'}}></th>*/}
                            {/*    </tr>*/}
                            {/*</thead>*/}
                            <tbody>
                                {route.enabledRoutes && Object.entries(route.enabledRoutes).sort((a, b) => {
                                    return a.position - b.position
                                }).map(([index, cliffRoute]) => {
                                    return <DetailsCliffRouteItem key={cliffRoute.id}
                                                                  index={index}
                                                                  route={route}
                                                                  cliffRoute={cliffRoute}
                                                                  tickingRootUrl={tickingRootUrl}
                                                                  open={openId === cliffRoute.id}
                                                                  setOpen={setOpenIdCallback}
                                    />
                                })}
                            </tbody>
                        </table>

                    </React.Fragment>
    }

    if (type === Constants.TypeTopo.GRANDEVOIE) {
        bottomContent =
            <div className='mx-2'>
                {(route.movement || route?.descentDetailFace || route.descentDetail) && <div className="wysiwyg">
                    {route.movement && <>
                        <h3 className="mt-1">
                            {t('detailsScreen.movement')}
                        </h3>
                        <div dangerouslySetInnerHTML={{__html: route.movement}}/>
                    </>}

                    {(route.descentDetailFace || route.descentDetail) && <>
                        <h3 className="mt-1">
                            {t('detailsScreen.descentDetail')}
                        </h3>

                        {route?.descentDetail && <p dangerouslySetInnerHTML={{__html: route.descentDetail}}/>}
                        {route?.descentDetailFace && <p dangerouslySetInnerHTML={{__html: route.descentDetailFace}}/>}
                    </>}
                </div>}
            </div>
    }

    return (
        <SplitComponent
            topContent={topContent}
            bottomContent={bottomContent}
            />
    );
}

const mapStateToProps = (state) => {
    return {
        bookmark: state.navbar.bookmark
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onUpdateBookmark: (url) => {
            dispatch(updateBookmark(url))
        },
    }
};

export default
    compose(
        withTranslation(),
        connect(
            mapStateToProps,
            mapDispatchToProps
        )
    )(DetailsComponent);